import { render, staticRenderFns } from "./DxfViewer.vue?vue&type=template&id=b6bd3c1a&scoped=true"
import script from "./DxfViewer.vue?vue&type=script&lang=js"
export * from "./DxfViewer.vue?vue&type=script&lang=js"
import style0 from "./DxfViewer.vue?vue&type=style&index=0&id=b6bd3c1a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_f9e102e5cbb5fa5aa7d45569a28cebe6/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6bd3c1a",
  null
  
)

export default component.exports